
<template>
	<div>
		<div class="">
			
		<div class="container">
			<hr>
			<b-button v-b-toggle.collapse-1 class="main-btn" variant="">Update the Meta</b-button>
			<b-collapse id="collapse-1" class="mt-2">
				<b-card>

				<template v-for="(componentItem, index) in contentClone">						
					<section :key="index" >
						<template v-if="index !== 'componentData'">
							<GenericField
								v-if="sampleContent"
								:component-item="componentItem"
								:index="index"
								:contentClone="contentClone"
								:sampleContent="sampleContent"
							/>
						</template>
					</section>
				</template>
				</b-card>
			</b-collapse>
		</div>
		
			<br>
		
			
			<div class="container">
				<b-button v-b-toggle.collapse-1 variant="" class="main-btn">Update the content</b-button>
				<b-collapse  visible id="collapse-1" class="mt-2">
					<b-card>
					<form>
						<template v-for="(componentItem, index) in contentClone.componentData">						
							<section :key="index" class="container">
								<template>
									<EditButtons :content-clone="contentClone" :index="index" :component-name="componentItem.template" />
									<Hero :component-item="componentItem" :index="index" v-if="componentItem.template == 'hero'"/>
									<AnimatedImage :component-item="componentItem" :index="index" v-if="componentItem.template === 'animated-image'"/>
									<SummaryText :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'summary-text'"/>
									<ImageAndBodyCopy :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'image-and-body-copy'" :sample-content="getSampleForComponent(componentItem.template)"/>
									<Quote :component-item="componentItem" :index="index" v-if="componentItem.template == 'quote'" :sample-content="getSampleForComponent(componentItem.template)"/>
									<AcastQuote :component-item="componentItem" :index="index" v-if="componentItem.template == 'acast-quote'" :sample-content="getSampleForComponent(componentItem.template)"/>
									<Social :component-item="componentItem" :index="index" v-if="componentItem.template == 'social'"/>
									<PodcastSubscribe :component-item="componentItem" :index="index" v-if="componentItem.template == 'podcast-subscribe'"/>
									<MoreContentUnit :component-item="componentItem" :index="index" v-if="componentItem.template == 'more-content-unit'"/>
									<BioBubble :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'bio-bubble'"/>
									<Ad :component-item="componentItem" :index="index" v-if="
										componentItem.template == 'ad-leaderboard' ||
										componentItem.template == 'ad-billboard' ||
										componentItem.template == 'ad-mpu' ||
										componentItem.template == 'ad-mobile'"/>
									<Audio :component-item="componentItem" :sample-content="getSampleForComponent(componentItem.template)" :index="index" v-if="componentItem.template == 'audio'"/>
									<ClientBox :component-item="componentItem" :index="index" v-if="componentItem.template == 'client-box'" :sample-content="getSampleForComponent(componentItem.template)"/>
									<Video :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'video'"/>
									<ImageSlideshows :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'image-slideshows'"/>
									<Credits :component-item="componentItem" :index="index" :componentTemplates="componentTemplates" v-if="componentItem.template == 'credits'"/>
									<hr>
								</template>
							</section>
						</template>

						<div class="mb-5 select_container">
							<select v-model="newComponent">
								<option value="">Select component:</option>
								<option
									v-for="(componentItem, index) in componentTemplates"
									:value="componentItem['template']"
									:key="index">
									{{ componentItem['template'] }}
								</option>
							</select>	
							<button type="submit" class="btn m-2" @click.stop.prevent="addComponent">
								<img src="~@/assets/icons/add.svg" />
							</button>
						</div>	

					</form>

					</b-card>
				</b-collapse>
		</div>
		
			<div class="fixed-container">
				<button type="submit" class="btn btn-primary" @click.stop.prevent="saveForm">Save</button>
				<button type="submit" class="btn btn-primary build-and-preview" v-if="!loading" @click.stop.prevent="toggleBuildPreview">Build &amp; Preview</button>
				<p><img src="~@/assets/images/gradient_load.gif" class="preloader" v-if="loading"><p>
				<p v-if="getCognitoErrorStatus === 'success'">
					{{ getCognitoErrorMessage }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { UPDATE_CONTENT } from '@/store/actions/user'
	import { mapGetters } from 'vuex'
	import api from '@/utils/api';
	import routes from '@/router';
	import EditButtons from './components/EditButtons.vue';
	import Hero from './components/componentData/Hero';
	import BioBubble from './components/componentData/BioBubble';
	import SummaryText from './components/componentData/SummaryText';
	import ImageAndBodyCopy from './components/componentData/ImageAndBodyCopy';
	import AnimatedImage from './components/componentData/AnimatedImage.vue';
	import GenericField from './components/GenericField.vue';
	import Quote from './components/componentData/Quote.vue';
	import AcastQuote from './components/componentData/AcastQuote.vue';
	import Social from './components/componentData/Social.vue';
	import PodcastSubscribe from './components/componentData/PodcastSubscribe.vue';
	import Ad from './components/componentData/Ad.vue';
	import MoreContentUnit from './components/componentData/MoreContentUnit.vue';
	import ClientBox from './components/componentData/ClientBox.vue';
	import Video from './components/componentData/Video.vue';
	import ImageSlideshows from './components/componentData/ImageSlideshows.vue';
	import Credits from './components/componentData/Credits.vue';
	import Audio from './components/componentData/Audio.vue'

	export default {
		components: {
			GenericField,
			Hero,
			SummaryText,
			BioBubble,
			ImageAndBodyCopy,
			AnimatedImage,
			Quote,
			AcastQuote,
			EditButtons,
			Social,
			PodcastSubscribe,
			Ad,
			MoreContentUnit,
			ClientBox,
			Video,
			ImageSlideshows,
			Credits,
			Audio
		},

		name: 'feedItem',
	
		
		data () {
			return {
				contentClone: '',
				initialContent:'',
				sampleContent: '',
				newComponent: '',
				componentTemplates: '',
				slideritems: [
					{ showEdit: false},
					{ showEdit: false}
				],
			}
		},

		props: ['toggleBuildPreview'],

		methods: {
			getContent(){
				let url = `content?repository=${routes.app.$route.params.repoName}`
				let self = this;

				api({ url: url  })
				.then(response =>  {
					self.initialContent = response.data;
					self.contentClone = JSON.parse(JSON.stringify({ ...self.initialContent }));
				})
			},
			getSample(){
				let url = `sample?repository=${routes.app.$route.params.repoName}`;
				let self = this;

				api({ url: url  })
				.then(response =>  {
					self.sampleContent = response.data;
					self.componentTemplates = response.data.componentData;
				})
			},
			getSampleForComponent(templateName){

				let matchedElement = null

				if(this.sampleContent !== ""){
					this.sampleContent['componentData'].forEach(element => {
						if(element.template === templateName){
							matchedElement = element.content
						}
						
					});
				}

				if(matchedElement){
					return matchedElement
				}else{
					return "EMPTY!"
				}

			},
			openEditor(slider) {
				slider.showEdit = true
			},
			closeEditor(slider) {
				slider.showEdit = false
			},
			saveForm() {
				this.$store.dispatch(UPDATE_CONTENT, JSON.parse(JSON.stringify(this.contentClone)));
			},

			addComponent() {
				for(let i = 0; i < this.componentTemplates.length; i++) {
					if(this.componentTemplates[i]['template'] === this.newComponent) {
						this.contentClone.componentData.push(
							JSON.parse(JSON.stringify(this.componentTemplates[i]))
						);

						break;
					}
				}
			}

		},

		beforeMount () {
			this.getContent()
			this.getSample()
		},

		computed: {
			...mapGetters([ 'getCognitoErrorStatus', 'getCognitoErrorMessage']),

			contentState() {
				return JSON.stringify({ ...self.initialContent });
			},

			loading () {
				if ( this.getCognitoErrorStatus == 'loading'){
					return true;
				}else{
					return null;
				}
			}
		},
	}

</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}

	.preloader {
		height: 36px;
		vertical-align: middle;
		position: absolute;
		top: 0;
		left: 50%;
			position: absolute;
		top: 28%;
		right: 0;
		left: 0;
		margin: 0 auto;	
	}

	.build-and-preview{
		display: none;
	}

	.fixed-container {
		position: sticky;
		bottom: 0;
		// padding: 5px 0;
		background: white;
		display: flex;
		justify-content: center;
		z-index: 15;
		padding: 25px 0;
		box-shadow: 0px 0px 6px grey;

		button {
			align-self: flex-start !important;
			margin-right: 15px;
			flex-shrink: 0;
		}

	}

.main-btn{
	width:100%;
}
.select_container{
	text-align: center;
}

	
</style>